import { slice, equals, pipe, concat, __, unless, defaultTo, match, join } from 'ramda';

const defaultToEmptyArray = defaultTo([]);

const isEmptyString = equals('');

const matchDigits = pipe(match(/\d/g), defaultToEmptyArray);
const filterDigits = pipe(
	defaultTo(''),
	matchDigits,
	join('')
);

export const whitespace = concat(' ');
export const plus = concat('+');
export const dash = concat('-');

const maybe375or380 = (f) => (
	f(plus, 3) +
	f(whitespace, 2) +
	f(whitespace, 3) +
	f(dash, 2) +
	f(dash, 2)
);

const parsers = {
	'7': (f) => (
		f(plus, 1) +
		f(whitespace, 3) +
		f(whitespace, 3) +
		f(dash, 2) +
		f(dash, 2)
	),
	'375': maybe375or380,
	'380': maybe375or380,
}

function applyMask(digits, formatter) {
	let acc = 0;

	const sliceIncludesToDigits = (prepender, count) => {
		const to = acc + count;
		const value = unless(
			isEmptyString,
			prepender,
			slice(acc, to, digits)
		);

		acc = to;

		return value;
	}

	return formatter(sliceIncludesToDigits);
}

function getFormatterByRegion(digits) {
	const codes = Object.keys(parsers);

	for (let code of codes) {
		if (digits.startsWith(code)) {
			return parsers[code];
		}
	}
}

/**
 *
 * @param {string} value
 * @returns {string}
 */
export function format(value) {
	const filteredValue = filterDigits(value);
	const formatter = getFormatterByRegion(filteredValue);

	if (!formatter)
		return filteredValue;

	return applyMask(filteredValue, formatter);
}
